export const FETCH_RECIPIENT_REQUEST = 'FETCH_RECIPIENT_REQUEST';
export const FETCH_RECIPIENT_SUCCESS = 'FETCH_RECIPIENT_SUCCESS';
export const FETCH_RECIPIENT_FAILURE = 'FETCH_RECIPIENT_FAILURE';
export const FETCH_RECIPIENTS_REQUEST = 'FETCH_RECIPIENTS_REQUEST';
export const FETCH_RECIPIENTS_SUCCESS = 'FETCH_RECIPIENTS_SUCCESS';
export const FETCH_RECIPIENTS_FAILURE = 'FETCH_RECIPIENTS_FAILURE';
export const SELECT_RECIPIENT = 'SELECT_RECIPIENT';
export const FETCH_RECIPIENT_COUNTRIES_REQUEST =
  'FETCH_RECIPIENT_COUNTRIES_REQUEST';
export const FETCH_RECIPIENT_COUNTRIES_SUCCESS =
  'FETCH_RECIPIENT_COUNTRIES_SUCCESS';
